<div class="min-h-screen bg-gray-900 py-8">
  <app-notification></app-notification>
  
  <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="flex items-center justify-between mb-8">
      <div class="flex items-center gap-4">
        <button
          (click)="cancel()"
          class="p-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div>
          <h1 class="text-2xl font-bold text-white">
            {{ isNewProject ? 'Nieuw Project' : 'Project Bewerken' }}
          </h1>
          <p class="text-sm text-gray-400">Vul de projectgegevens in voor alle talen</p>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <a *ngIf="previewUrl"
          [href]="previewUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-300 hover:text-white border border-gray-600 hover:border-gray-500 rounded-lg transition-colors"
          title="Open preview op Vercel met domein-override (geen cache)">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          Bekijk preview
        </a>
        <button
          (click)="cancel()"
          class="px-4 py-2 text-gray-300 hover:text-white transition-colors">
          Annuleren
        </button>
        <button
          (click)="saveProject()"
          [disabled]="isSaving"
          class="inline-flex items-center px-5 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <svg *ngIf="isSaving" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <svg *ngIf="!isSaving" class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          {{ isSaving ? 'Opslaan...' : 'Opslaan' }}
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex justify-center items-center py-20">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
    </div>

    <!-- Form Content -->
    <div *ngIf="!isLoading" class="space-y-6">
      <!-- Language Tabs -->
      <div class="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden">
        <div class="flex border-b border-gray-700 overflow-x-auto">
          <button
            *ngFor="let lang of availableLanguages"
            (click)="setEditLanguage(lang.code)"
            class="px-6 py-4 text-sm font-medium transition-colors border-b-2 -mb-px whitespace-nowrap"
            [ngClass]="currentLocale === lang.code ? 'text-indigo-400 border-indigo-400 bg-gray-900/50' : 'text-gray-400 border-transparent hover:text-white hover:bg-gray-700/50'">
            {{ lang.name }}
          </button>
        </div>

        <div class="p-6 space-y-6">
          <!-- Title -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Titel ({{ currentLocale.toUpperCase() }})
              <span *ngIf="currentLocale === 'nl'" class="text-red-400 ml-1">*</span>
            </label>
            <input
              type="text"
              [(ngModel)]="project['title_' + currentLocale]"
              (ngModelChange)="onTitleChange()"
              placeholder="Voer een titel in"
              class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          </div>

          <!-- Slug (SEO URL) -->
          <div *ngIf="currentLocale === 'nl'">
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Slug (SEO URL)
            </label>
            <div class="flex gap-2">
              <div class="flex-1 relative">
                <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">/projecten/</span>
                <input
                  type="text"
                  [(ngModel)]="project.slug"
                  (ngModelChange)="onSlugChange()"
                  placeholder="project-naam"
                  class="w-full pl-24 pr-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
              </div>
              <button
                type="button"
                (click)="regenerateSlug()"
                class="px-3 py-2 bg-gray-600 text-gray-300 rounded-lg hover:bg-gray-500 hover:text-white transition-colors"
                title="Slug opnieuw genereren vanuit titel">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </button>
            </div>
            <p class="mt-1 text-xs text-gray-500">Wordt automatisch gegenereerd vanuit de titel. Je kunt het handmatig aanpassen.</p>
          </div>

          <!-- Short Description -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Korte beschrijving ({{ currentLocale.toUpperCase() }})
            </label>
            <textarea
              [(ngModel)]="project['short_description_' + currentLocale]"
              rows="2"
              placeholder="Een korte samenvatting van het project"
              class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"></textarea>
            <p class="mt-1 text-xs text-gray-500">Wordt gebruikt in overzichten en previews</p>
          </div>

          <!-- Description -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Volledige beschrijving ({{ currentLocale.toUpperCase() }})
            </label>
            <editor
              [(ngModel)]="project['description_' + currentLocale]"
              [init]="editorConfig">
            </editor>
          </div>

          <!-- Location -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Projectplaats ({{ currentLocale.toUpperCase() }})
            </label>
            <input
              type="text"
              [(ngModel)]="project['location_' + currentLocale]"
              placeholder="Bijv. Bergen op Zoom,"
              class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          </div>

          <!-- Client -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Opdrachtgever ({{ currentLocale.toUpperCase() }})
            </label>
            <input
              type="text"
              [(ngModel)]="project['client_' + currentLocale]"
              placeholder="Bijv. Dutchwatertech b.v."
              class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          </div>

          <!-- Application -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Toepassing ({{ currentLocale.toUpperCase() }})
            </label>
            <textarea
              [(ngModel)]="project['application_' + currentLocale]"
              rows="2"
              placeholder="Bijv. Beplanting"
              class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"></textarea>
            <p class="mt-1 text-xs text-gray-500">Beschrijf welke producten/diensten gebruikt zijn</p>
          </div>

          <!-- Planting Scheme -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Plantschema ({{ currentLocale.toUpperCase() }})
            </label>
            <input
              type="text"
              [(ngModel)]="project['plantingScheme_' + currentLocale]"
              placeholder="Bijv. Carophyllus"
              class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          </div>

          <!-- Extra -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Extra ({{ currentLocale.toUpperCase() }})
            </label>
            <input
              type="text"
              [(ngModel)]="project['extra_' + currentLocale]"
              placeholder="Bijv. Gebruikte producten"
              class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          </div>
        </div>
      </div>

      <!-- Project Details -->
      <div class="bg-gray-800 rounded-xl border border-gray-700 p-6">
        <h2 class="text-lg font-semibold text-white mb-6">Projectgegevens</h2>
        
        <div class="grid grid-cols-1 gap-6">
          <!-- Main Category (Hoofdcategorie) -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Hoofdcategorie</label>
            <p class="text-xs text-gray-500 mb-3">Selecteer de primaire categorie van het project</p>

            <!-- Current main category display -->
            <div *ngIf="project.mainCategory" class="flex items-center gap-2 mb-4">
              <span class="inline-flex items-center px-3 py-1.5 bg-emerald-600/20 text-emerald-300 text-sm rounded-lg font-medium">
                <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
                {{ project.mainCategory }}
                <button
                  type="button"
                  (click)="clearMainCategory()"
                  class="ml-2 text-emerald-300 hover:text-white transition-colors">
                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </span>
            </div>

            <!-- Existing main categories selection -->
            <div *ngIf="!showNewMainCategoryInput && existingMainCategories.length > 0" class="space-y-3">
              <div class="flex flex-wrap gap-2">
                <button
                  *ngFor="let cat of existingMainCategories"
                  type="button"
                  (click)="setMainCategory(cat)"
                  class="px-3 py-1.5 text-sm rounded-lg transition-colors"
                  [ngClass]="project.mainCategory === cat ? 'bg-emerald-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  <span class="flex items-center gap-1.5">
                    <svg *ngIf="project.mainCategory === cat" class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {{ cat }}
                  </span>
                </button>
              </div>
              <button
                type="button"
                (click)="showAddNewMainCategory()"
                class="flex items-center gap-1 text-sm text-emerald-400 hover:text-emerald-300 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Nieuwe hoofdcategorie toevoegen
              </button>
            </div>

            <!-- No main categories yet -->
            <div *ngIf="!showNewMainCategoryInput && existingMainCategories.length === 0" class="space-y-3">
              <p class="text-sm text-gray-400">Nog geen hoofdcategorieën. Maak de eerste aan:</p>
              <div class="flex gap-2">
                <input
                  type="text"
                  [(ngModel)]="newMainCategoryValue"
                  placeholder="Bijv. Drijvende Eilanden"
                  (keyup.enter)="addNewMainCategory()"
                  class="flex-1 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent">
                <button
                  type="button"
                  (click)="addNewMainCategory()"
                  class="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-500 transition-colors">
                  Toevoegen
                </button>
              </div>
            </div>

            <!-- New main category input -->
            <div *ngIf="showNewMainCategoryInput && existingMainCategories.length > 0" class="flex gap-2 mt-3">
              <input
                type="text"
                [(ngModel)]="newMainCategoryValue"
                placeholder="Nieuwe hoofdcategorie naam"
                (keyup.enter)="addNewMainCategory()"
                class="flex-1 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent">
              <button
                type="button"
                (click)="addNewMainCategory()"
                class="px-3 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-500 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </button>
              <button
                type="button"
                (click)="cancelNewMainCategory()"
                class="px-3 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-500 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Subcategories (was: Categorieën) -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">Subcategorieën</label>
            <p class="text-xs text-gray-500 mb-3">Selecteer één of meerdere subcategorieën</p>
            
            <!-- Selected categories display -->
            <div *ngIf="project.categories && project.categories.length > 0" class="flex flex-wrap gap-2 mb-4">
              <span *ngFor="let cat of project.categories" class="inline-flex items-center px-3 py-1.5 bg-indigo-600/20 text-indigo-300 text-sm rounded-lg">
                {{ cat }}
                <button 
                  type="button"
                  (click)="removeCategory(cat)"
                  class="ml-2 text-indigo-300 hover:text-white transition-colors">
                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </span>
            </div>

            <!-- Existing categories selection -->
            <div *ngIf="!showNewCategoryInput && existingCategories.length > 0" class="space-y-3">
              <div class="flex flex-wrap gap-2">
                <button 
                  *ngFor="let cat of existingCategories"
                  type="button"
                  (click)="toggleCategory(cat)"
                  class="px-3 py-1.5 text-sm rounded-lg transition-colors"
                  [ngClass]="isCategorySelected(cat) ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'">
                  <span class="flex items-center gap-1.5">
                    <svg *ngIf="isCategorySelected(cat)" class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {{ cat }}
                  </span>
                </button>
              </div>
              <button 
                type="button"
                (click)="showAddNewCategory()"
                class="flex items-center gap-1 text-sm text-indigo-400 hover:text-indigo-300 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Nieuwe subcategorie toevoegen
              </button>
            </div>

            <!-- No categories yet - show input to create first -->
            <div *ngIf="!showNewCategoryInput && existingCategories.length === 0" class="space-y-3">
              <p class="text-sm text-gray-400">Nog geen categorieën. Maak de eerste aan:</p>
              <div class="flex gap-2">
                <input
                  type="text"
                  [(ngModel)]="newCategoryValue"
                  placeholder="Bijv. Bio-float"
                  (keyup.enter)="addNewCategory()"
                  class="flex-1 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
                <button 
                  type="button"
                  (click)="addNewCategory()"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-500 transition-colors">
                  Toevoegen
                </button>
              </div>
            </div>

            <!-- New category input -->
            <div *ngIf="showNewCategoryInput && existingCategories.length > 0" class="flex gap-2 mt-3">
              <input
                type="text"
                [(ngModel)]="newCategoryValue"
                placeholder="Nieuwe categorie naam"
                (keyup.enter)="addNewCategory()"
                class="flex-1 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
              <button 
                type="button"
                (click)="addNewCategory()"
                class="px-3 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-500 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </button>
              <button 
                type="button"
                (click)="cancelNewCategory()"
                class="px-3 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-500 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Main Image Upload -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">Hoofdafbeelding</label>
          
          <!-- Current image preview -->
          <div *ngIf="project.image && !isUploading" class="mb-4">
            <div class="relative inline-block">
              <img [src]="project.image" alt="Preview" class="w-48 h-48 object-cover rounded-lg border border-gray-600">
              <button 
                type="button"
                (click)="removeMainImage()"
                class="absolute -top-2 -right-2 p-1.5 bg-red-600 text-white rounded-full hover:bg-red-500 transition-colors shadow-lg">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div *ngIf="project.imageVariants" class="mt-2 text-xs text-gray-500">
              <span class="inline-flex items-center gap-1">
                <svg class="w-3 h-3 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
                4 varianten opgeslagen
              </span>
            </div>
          </div>

          <!-- Upload progress -->
          <div *ngIf="isUploading" class="mb-4 p-4 bg-gray-700/50 rounded-lg border border-gray-600">
            <div class="flex items-center justify-between mb-2">
              <span class="text-sm text-gray-300">{{ uploadStatus }}</span>
              <span class="text-sm text-indigo-400">{{ uploadProgress }}%</span>
            </div>
            <div class="w-full bg-gray-600 rounded-full h-2">
              <div class="bg-indigo-500 h-2 rounded-full transition-all duration-300" [style.width.%]="uploadProgress"></div>
            </div>
          </div>

          <!-- Upload buttons -->
          <div *ngIf="!isUploading && !project.image" class="flex flex-wrap gap-3">
            <label class="inline-flex items-center px-4 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
              </svg>
              Uploaden
              <input 
                type="file" 
                accept="image/*"
                (change)="onMainImageSelected($event)"
                class="hidden">
            </label>
            <button
              type="button"
              (click)="openMediaSelector('main')"
              class="inline-flex items-center px-4 py-2.5 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors border border-gray-600">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Uit mediabibliotheek
            </button>
          </div>
        </div>

        <!-- Gallery -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">Galerij</label>
          <p class="text-xs text-gray-500 mb-3">Voeg meerdere afbeeldingen toe voor een galerij</p>
          
          <!-- Gallery images grid -->
          <div *ngIf="project.gallery && project.gallery.length > 0" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-4">
            <div *ngFor="let img of project.gallery; let i = index" class="relative group">
              <img [src]="img.url" alt="Gallery image" class="w-full h-24 object-cover rounded-lg border border-gray-600">
              <button 
                type="button"
                (click)="removeGalleryImage(i)"
                class="absolute -top-2 -right-2 p-1 bg-red-600 text-white rounded-full hover:bg-red-500 transition-colors shadow-lg opacity-0 group-hover:opacity-100">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <div *ngIf="img.variants" class="absolute bottom-1 right-1">
                <svg class="w-3 h-3 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Add gallery images buttons -->
          <div *ngIf="!isUploading" class="flex flex-wrap gap-3">
            <label class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors cursor-pointer border border-gray-600">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              Afbeeldingen toevoegen
              <input 
                type="file" 
                accept="image/*"
                multiple
                (change)="onGalleryImagesSelected($event)"
                class="hidden">
            </label>
            <button
              type="button"
              (click)="openMediaSelector('gallery')"
              class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors border border-gray-600">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Uit mediabibliotheek
            </button>
          </div>
        </div>

        <!-- Before Images -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">Voor Afbeeldingen</label>
          <p class="text-xs text-gray-500 mb-3">Afbeeldingen van de situatie voor het project</p>
          
          <!-- Before images grid -->
          <div *ngIf="project.beforeImages && project.beforeImages.length > 0" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-4">
            <div *ngFor="let img of project.beforeImages; let i = index" class="relative group">
              <img [src]="img.url" alt="Before image" class="w-full h-24 object-cover rounded-lg border border-gray-600">
              <button 
                type="button"
                (click)="removeBeforeImage(i)"
                class="absolute -top-2 -right-2 p-1 bg-red-600 text-white rounded-full hover:bg-red-500 transition-colors shadow-lg opacity-0 group-hover:opacity-100">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <div *ngIf="img.variants" class="absolute bottom-1 right-1">
                <svg class="w-3 h-3 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Add before images buttons -->
          <div *ngIf="!isUploading" class="flex flex-wrap gap-3">
            <label class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors cursor-pointer border border-gray-600">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              Voor afbeeldingen toevoegen
              <input 
                type="file" 
                accept="image/*"
                multiple
                (change)="onBeforeImagesSelected($event)"
                class="hidden">
            </label>
            <button
              type="button"
              (click)="openMediaSelector('before')"
              class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors border border-gray-600">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Uit mediabibliotheek
            </button>
          </div>
        </div>

        <!-- After Images -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">Na Afbeeldingen</label>
          <p class="text-xs text-gray-500 mb-3">Afbeeldingen van de situatie na het project</p>
          
          <!-- After images grid -->
          <div *ngIf="project.afterImages && project.afterImages.length > 0" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-4">
            <div *ngFor="let img of project.afterImages; let i = index" class="relative group">
              <img [src]="img.url" alt="After image" class="w-full h-24 object-cover rounded-lg border border-gray-600">
              <button 
                type="button"
                (click)="removeAfterImage(i)"
                class="absolute -top-2 -right-2 p-1 bg-red-600 text-white rounded-full hover:bg-red-500 transition-colors shadow-lg opacity-0 group-hover:opacity-100">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <div *ngIf="img.variants" class="absolute bottom-1 right-1">
                <svg class="w-3 h-3 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Add after images buttons -->
          <div *ngIf="!isUploading" class="flex flex-wrap gap-3">
            <label class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors cursor-pointer border border-gray-600">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              Na afbeeldingen toevoegen
              <input 
                type="file" 
                accept="image/*"
                multiple
                (change)="onAfterImagesSelected($event)"
                class="hidden">
            </label>
            <button
              type="button"
              (click)="openMediaSelector('after')"
              class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors border border-gray-600">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Uit mediabibliotheek
            </button>
          </div>
        </div>

        <!-- YouTube -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">YouTube Video</label>
          <input
            type="url"
            [(ngModel)]="project.youtube"
            placeholder="https://www.youtube.com/watch?v=..."
            class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          <p class="mt-1 text-xs text-gray-500">Plak een YouTube link om een video te embedden</p>
          
          <!-- YouTube preview -->
          <div *ngIf="project.youtube && getYouTubeEmbedUrl()" class="mt-3">
            <div class="relative bg-gray-700 rounded-lg overflow-hidden aspect-video">
              <iframe 
                [src]="getYouTubeEmbedUrl() | safeUrl" 
                class="absolute inset-0 w-full h-full"
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>

        <!-- Project URL -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">Project URL</label>
          <input
            type="url"
            [(ngModel)]="project.url"
            placeholder="https://example.com"
            class="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
        </div>

        <!-- Tags -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">Tags</label>
          <div class="flex flex-wrap gap-2 mb-3">
            <span *ngFor="let tag of project.tags" class="inline-flex items-center px-3 py-1 bg-indigo-600/20 text-indigo-300 text-sm rounded-full">
              {{ tag }}
              <button (click)="removeTag(tag)" class="ml-2 hover:text-white">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </span>
          </div>
          <div class="flex gap-2">
            <input
              #tagInput
              type="text"
              placeholder="Voeg een tag toe"
              (keyup.enter)="addTag(tagInput)"
              class="flex-1 px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
            <button
              type="button"
              (click)="addTag(tagInput)"
              class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-500 transition-colors">
              Toevoegen
            </button>
          </div>
        </div>

        <!-- Related Projects -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-300 mb-2">Gerelateerde Projecten</label>
          <p class="text-xs text-gray-500 mb-3">Selecteer projecten die gerelateerd zijn aan dit project</p>
          
          <!-- Selected related projects -->
          <div *ngIf="project.relatedProjectIds && project.relatedProjectIds.length > 0" class="flex flex-wrap gap-2 mb-3">
            <span *ngFor="let projectId of project.relatedProjectIds" class="inline-flex items-center px-3 py-1.5 bg-indigo-600/20 text-indigo-300 text-sm rounded-lg">
              {{ getRelatedProjectTitle(projectId) }}
              <button 
                type="button"
                (click)="removeRelatedProject(projectId)"
                class="ml-2 text-indigo-300 hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </span>
          </div>

          <!-- Select related projects button -->
          <button
            type="button"
            (click)="openRelatedProjectsSelector()"
            class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-medium rounded-lg transition-colors border border-gray-600">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Selecteer Gerelateerde Projecten
          </button>
        </div>

        <!-- Featured -->
        <div class="mt-6 flex items-center">
          <input
            type="checkbox"
            [(ngModel)]="project.featured"
            id="featured"
            class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500">
          <label for="featured" class="ml-2 text-sm text-gray-300">Uitgelicht project</label>
        </div>
      </div>

      <!-- Domains -->
      <div class="bg-gray-800 rounded-xl border border-gray-700 p-6">
        <h2 class="text-lg font-semibold text-white mb-4">Domeinen</h2>
        <p class="text-sm text-gray-400 mb-4">Selecteer op welke websites dit project zichtbaar moet zijn</p>
        <div class="flex flex-wrap gap-3">
          <label *ngFor="let domain of availableDomains" class="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              [checked]="isDomainSelected(domain)"
              (change)="toggleDomainSelection(domain)"
              class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500">
            <span class="ml-2 text-sm text-gray-300">{{ domain }}</span>
          </label>
        </div>
      </div>

      <!-- SEO -->
      <div class="bg-gray-800 rounded-xl border border-gray-700 p-6">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center">
            <svg class="w-5 h-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <div>
            <h2 class="text-lg font-semibold text-white">SEO</h2>
            <p class="text-sm text-gray-400">Zoekmachine-optimalisatie per taal</p>
          </div>
        </div>

        <!-- Language tabs -->
        <div class="flex gap-1 mb-6 bg-gray-900/50 rounded-lg p-1">
          <button
            *ngFor="let lang of availableLanguages"
            (click)="setEditLanguage(lang.code)"
            class="flex-1 px-3 py-1.5 text-sm font-medium rounded-md transition-colors"
            [ngClass]="currentLocale === lang.code ? 'bg-green-600 text-white' : 'text-gray-400 hover:text-white hover:bg-gray-700'">
            {{ lang.name }}
          </button>
        </div>

        <!-- SEO Title -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-300 mb-1">SEO Titel</label>
          <input
            type="text"
            [(ngModel)]="project['seo_title_' + currentLocale]"
            [placeholder]="project['title_' + currentLocale] || project.title || 'SEO titel...'"
            maxlength="70"
            class="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:ring-2 focus:ring-green-500 focus:border-transparent">
          <div class="flex justify-between mt-1">
            <span class="text-xs text-gray-500">Aanbevolen: 50-60 tekens</span>
            <span class="text-xs" [class]="(project['seo_title_' + currentLocale]?.length || 0) > 60 ? 'text-yellow-400' : 'text-gray-500'">
              {{ project['seo_title_' + currentLocale]?.length || 0 }} / 70
            </span>
          </div>
        </div>

        <!-- SEO Description -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-300 mb-1">SEO Beschrijving</label>
          <textarea
            [(ngModel)]="project['seo_description_' + currentLocale]"
            [placeholder]="project['short_description_' + currentLocale] || project.short_description || 'SEO beschrijving...'"
            maxlength="160"
            rows="3"
            class="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"></textarea>
          <div class="flex justify-between mt-1">
            <span class="text-xs text-gray-500">Aanbevolen: 120-155 tekens</span>
            <span class="text-xs" [class]="(project['seo_description_' + currentLocale]?.length || 0) > 155 ? 'text-yellow-400' : 'text-gray-500'">
              {{ project['seo_description_' + currentLocale]?.length || 0 }} / 160
            </span>
          </div>
        </div>

        <!-- SEO Keywords -->
        <div>
          <label class="block text-sm font-medium text-gray-300 mb-1">SEO Zoekwoorden</label>
          <input
            type="text"
            [(ngModel)]="project['seo_keywords_' + currentLocale]"
            placeholder="Kommagescheiden zoekwoorden..."
            class="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:ring-2 focus:ring-green-500 focus:border-transparent">
          <span class="text-xs text-gray-500 mt-1 block">Gescheiden door komma's, bijv: tuin, aanleg, groen</span>
        </div>
      </div>

      <!-- Bottom Action Bar -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-700">
        <button
          (click)="cancel()"
          class="px-5 py-2.5 text-gray-300 hover:text-white border border-gray-600 rounded-lg hover:bg-gray-700 transition-colors">
          Annuleren
        </button>
        <button
          (click)="saveProject()"
          [disabled]="isSaving"
          class="inline-flex items-center px-6 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <svg *ngIf="isSaving" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ isSaving ? 'Opslaan...' : 'Project Opslaan' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Media Selector Modal -->
<app-media-selector-modal
  [show]="showMediaSelector"
  (onSelect)="onMediaSelected($event)"
  (onClose)="closeMediaSelector()">
</app-media-selector-modal>

<!-- Related Projects Selector Modal -->
<app-project-selector-modal
  [show]="showRelatedProjectsSelector"
  [selectedProjectIds]="project.relatedProjectIds || []"
  [currentLocale]="currentLocale"
  (onSelect)="onRelatedProjectsSelected($event)"
  (onClose)="closeRelatedProjectsSelector()">
</app-project-selector-modal>
